export default {
  myOrganization: {},
  myOrganizationUpdate: {},
  settings: {},
}
